import { useEffect, useState } from 'react';
import Select from 'react-select';




function CopFilterList(props) {
  const [customOptionList, setCustomOptionList] = useState([]);

  useEffect(()=> {
    const customOption = props.copList?.map((item)=> {
      return ({...item, label:`${item.Corporate_Name }`})
    });
    if(customOption.length){
      setCustomOptionList(customOption);
    }
  },[props.copList]);




  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '42px',
      backgroundColor: '#ffffff',
      borderColor: state.isFocused ? '#60a5fa' : '#e5e7eb', // border-blue-400 or gray-200
      boxShadow: state.isFocused ? '0 0 0 3px rgba(219, 234, 254, 0.5)' : 'none', // ring-blue-100
      borderRadius: '0.5rem', // rounded-lg
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      width: '100%',
      '&:hover': {
        borderColor: state.isFocused ? '#60a5fa' : '#93c5fd', // border-blue-300
      }
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    valueContainer: base => ({
      ...base,
      padding: '2px 12px',
    }),
    placeholder: base => ({
      ...base,
      color: '#9ca3af', // gray-400
      fontSize: '0.875rem', // text-sm
    }),
    singleValue: base => ({
      ...base,
      color: '#374151', // gray-700
      fontSize: '0.875rem', // text-sm
      fontWeight: '500',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#eff6ff' : state.isFocused ? '#f9fafb' : '#ffffff',
      color: state.isSelected ? '#1d4ed8' : '#374151',
      fontSize: '0.875rem',
      cursor: 'pointer',
      padding: '10px 12px',
      '&:active': {
        backgroundColor: '#e0e7ff',
      }
    }),
    menu: base => ({
      ...base,
      borderRadius: '0.5rem',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // shadow-lg
      overflow: 'hidden',
      border: '1px solid #f3f4f6', // gray-100
      zIndex: 99999,
    }),
    menuPortal: base => ({ ...base, zIndex: 99999 })
  };

  return (
    <>
      <div className="w-full">
        <Select
          menuPlacement="auto"
          menuPosition="fixed"
          placeholder="Select Corporate"
          key={customOptionList.length} 
          options={customOptionList}   
          onChange={props?.onCopFilterSelect} 
          styles={customStyles} 
        />
      </div>
    </>
  );
}

export default CopFilterList;
